<form
    #formDirective="ngForm"
    [formGroup]="editform"
    (ngSubmit)="editform.valid && saveFn()"
    autocomplete="off"
>
    <!-- Location Name Row -->
    <div class="grid">
        <div class="col-12">
            <label class="control-label">Location Name
                <span style="color: red; font-size: 1.25rem">*</span>
            </label>
            <app-text-input
                formControlName="locationName"
                [label]="'Location Name'"
                [name]="'Location Name'"
                (input)="
                    _locationService.activeItem.locationName =
                        $event.target.value
                "
            ></app-text-input>
        </div>
    </div>

    <!-- Phone Row -->
    <div class="grid mt-4">
        <div class="col-12">
            <label class="control-label">Phone
                <span style="color: red; font-size: 1.25rem">*</span>
            </label>
            <app-phone-input
                [formControl]="$any(editform.controls)['phone']"
                (input)="
                    _locationService.activeItem.phone = $event.target.value
                "
            ></app-phone-input>
        </div>
    </div>

    <!-- Address Row -->
    <div class="grid mt-4">
        <div class="col-12">
            <label class="control-label">Address
                <span style="color: red; font-size: 1.25rem">*</span>
            </label>
            <app-text-input
                formControlName="address"
                [label]="'Address'"
                [name]="'address'"
                (input)="
                    _locationService.activeItem.address = $event.target.value
                "
            ></app-text-input>
        </div>
    </div>

    <!-- Zip Code, City, State Row -->
    <div class="grid mt-4">
        <div class="col-12 sm:col-6 md:col-4">
            <label class="control-label">{{ labels.zip }}
                <span *ngIf="!isPk" style="color: red; font-size: 1.25rem">*</span>
            </label>
            <input *ngIf="isPk" pInputText type="text" formControlName="zip" [placeholder]="labels.zipPlaceholder"
                [style]="{ 'margin-top': '7px', width: '100%' }" />
            <p-inputMask
                *ngIf="!isPk"
                formControlName="zip"
                mask="99999"
                placeholder="Zip Code"
                (onInput)="zipInputEvent($event.target.value)"
                [style]="{ 'margin-top': '7px', width: '100%' }"
            ></p-inputMask>
            <div
                *ngIf="f.zip.touched && f.zip.invalid"
                class="invalid-feedback"
            >
                <div *ngIf="f.zip.errors.required">zip code is required.</div>
            </div>
        </div>
        <div class="col-12 sm:col-6 md:col-4">
            <label class="control-label">City
                <span style="color: red; font-size: 1.25rem">*</span>
            </label>
            <span class="p-input-icon-right" [style]="{ width: '100%' }">
                <i class="pi pi-spin pi-spinner" *ngIf="showCityWait"></i>
                <app-text-input
                    formControlName="city"
                    [label]="'City'"
                    [name]="'city'"
                    (input)="
                        _locationService.activeItem.city = $event.target.value
                    "
                ></app-text-input>
            </span>
        </div>
        <div class="col-12 sm:col-6 md:col-4">
            <label class="control-label">{{ labels.state }}
                <span style="color: red; font-size: 1.25rem">*</span>
            </label>
            <p-dropdown
                [style]="{
                    width: '100%',
                    'margin-top': '7px'
                }"
                class="p-dropdown-1 w-full"
                appendTo="body"
                [options]="usaStates"
                [(ngModel)]="_locationService.activeItem.state"
                optionLabel="name"
                optionValue="abbreviation"
                [filter]="true"
                filterBy="name"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="isViewOnly"
            ></p-dropdown>
        </div>
    </div>

    <!-- Action Buttons -->
    <div class="grid mt-5">
        <div class="col-12 flex justify-content-end gap-2">
            <button
                pButton
                pRipple
                type="submit"
                label="Save"
                class="p-button"
                [disabled]="!editform.valid || showCityWait"
            ></button>
            <button
                pButton
                pRipple
                type="button"
                label="Cancel"
                class="p-button-outlined p-button-danger"
                (click)="cancelButtonClick()"
            ></button>
        </div>
    </div>
</form>
